import styled from 'styled-components';

import { Typography } from '@useblu/ocean-react';
import { breakpointTo } from '@useblu/utils';

import {
  colorInterfaceDarkUp,
  spacingStackXxxs,
} from '@useblu/ocean-tokens/web/tokens';

export const Container = styled.div`
  width: 100%;

  ${breakpointTo('bpMedium')} {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;

export const Title = styled(Typography).attrs({
  variant: 'heading5',
})`
  &&& {
    color: ${colorInterfaceDarkUp};
    margin: 0px;
    margin-bottom: ${spacingStackXxxs};
  }
`;

export const ChildBox = styled.div`
  width: 100%;

  ${breakpointTo('bpMedium')} {
    display: flex;
    flex-direction: column;
    flex: 1;

    form {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      flex: 1;
    }
  }
`;
